import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import WarningModal from 'shared-components/WarningModal/WarningModal';

import { requestRemoveFromCart as requestRemoveFromCartAction } from 'services/actions/cartActions';

import { track } from 'utils/segment';
import { getDeviceType } from 'utils/device';

const RemovalWarningPopup = ({
  variantToRemove,
  variantToRemoveParentProductId,
  hideRemovalWarning,
  requestRemoveFromCart,
  userId,
  role,
  subscriptionState,
  campaignId,
  campaignName,
}) => {
  const isOpen = variantToRemove !== null;

  const handleClickRemove = () => {
    hideRemovalWarning();
    requestRemoveFromCart(
      variantToRemove,
      variantToRemoveParentProductId,
      'OOS Removal Warning',
      'YES REMOVE',
      null
    );
  };

  const handleClickCancel = () => {
    hideRemovalWarning();
    track('Clicked Element', {
      user_id: userId,
      role,
      subscription_state: subscriptionState,
      campaign_id: campaignId,
      campaign_name: campaignName,
      experience: 'OOS Removal Warning',
      element_name: 'NEVERMIND',
      device: getDeviceType(),
    });
  };

  return (
    <WarningModal
      isOpen={isOpen}
      title="Are you sure you want to remove this Boost?"
      message="Quantities are limited and you might not have an opportunity to add this again!"
      cancelText="Nevermind"
      confirmText="Yes, I want to remove this product"
      onClickCancel={handleClickCancel}
      onClickConfirm={handleClickRemove}
    />
  );
};

RemovalWarningPopup.propTypes = {
  variantToRemove: PropTypes.string,
  variantToRemoveParentProductId: PropTypes.string,
  hideRemovalWarning: PropTypes.func.isRequired,
  requestRemoveFromCart: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
  role: PropTypes.string.isRequired,
  subscriptionState: PropTypes.string.isRequired,
  campaignId: PropTypes.number.isRequired,
  campaignName: PropTypes.string.isRequired,
};

RemovalWarningPopup.defaultProps = {
  variantToRemove: null,
  variantToRemoveParentProductId: null,
};

const mapStateToProps = (state) => {
  return {
    userId: state.userState.userId,
    role: state.userState.role,
    subscriptionState: state.userState.subscriptionState,
    campaignId: state.campaignState.campaignId,
    campaignName: state.campaignState.campaignName,
  };
};

export default connect(mapStateToProps, {
  requestRemoveFromCart: requestRemoveFromCartAction,
})(RemovalWarningPopup);
